import { Gruppo } from './gruppo';
import { ModelWithAddressAndContactInfo } from './model-with-address-contact-info';

export class Compagnia extends ModelWithAddressAndContactInfo {
  static apiUrl: string = "compagnie";

  nome: string;
  gruppo: Gruppo;
  concordato_visibile: boolean;

  deserialize(input: any): Compagnia {
    let retV: Compagnia = new Compagnia();
    retV = super.deserialize(input) as Compagnia;

    if (input?.gruppo) {
      retV.gruppo = new Gruppo().deserialize(input.gruppo);
    }

    retV.concordato_visibile = !!input?.concordato_visibile;

    return retV;
  }

}
